import { EmployeeGroupFragment, EmployeeGroupsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface EmployeeGroups {
  loading: boolean
  employeeGroups: EmployeeGroupFragment[]
}

export const useEmployeeGroups = (): EmployeeGroups => {
  const { data, loading } = useQuery(EmployeeGroupsDocument, {})

  return {
    loading,
    employeeGroups: data?.employees.employeeGroupsConnection.nodes ?? [],
  }
}
